import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import CTAButton from './CTAButton';
interface FAQItemProps {
  question: string;
  answer: string;
}
const FAQItem: React.FC<FAQItemProps> = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 py-4" data-id="element-66">
      <button className="flex justify-between items-center w-full text-left" onClick={() => setIsOpen(!isOpen)} data-id="element-67">
        <h3 className="font-medium text-lg" data-id="element-68">{question}</h3>
        {isOpen ? <ChevronUpIcon className="text-primary flex-shrink-0" data-id="element-69" /> : <ChevronDownIcon className="text-primary flex-shrink-0" data-id="element-70" />}
      </button>
      {isOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} transition={{
      duration: 0.3
    }} className="mt-2" data-id="element-71">
          <p data-id="element-72">{answer}</p>
        </motion.div>}
    </div>;
};
const FAQSection: React.FC = () => {
  const faqs = [{
    question: '¿Necesito saber cocinar?',
    answer: 'No. Recetas simples y rápidas.'
  }, {
    question: '¿Se puede hacer si trabajo mucho?',
    answer: 'Sí. Plan pensado para mujeres ocupadas.'
  }, {
    question: '¿Hay que contar calorías?',
    answer: 'No. No vamos por ahí.'
  }, {
    question: '¿Voy a pasar hambre?',
    answer: 'No. Este no es un castigo.'
  }, {
    question: '¿Hay que eliminar todo lo dulce?',
    answer: 'No. Aprenderás sustitutos saludables.'
  }];
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="w-full bg-white py-16" data-id="element-73">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-75">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-secondary mb-2" data-id="element-76">
            Preguntas frecuentes
          </h2>
        </motion.div>
        <div className="bg-background p-8 rounded-2xl shadow-lg mb-12" data-id="element-77">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-78" />)}
        </div>
        <div className="text-center" data-id="element-79">
          <CTAButton className="text-xl py-4 px-10" onClick={scrollToPricing} data-id="element-80">
            EMPIEZO HOY MISMO
          </CTAButton>
        </div>
      </div>
    </section>;
};
export default FAQSection;